<template>
  <form id="fmStatusStep" @submit.prevent="" >
    <!-- เลือกรูปแบบสถานะใบสั่งตรวจ : 3 หรือ 4 ขั้นตอน -->
    <div class="row">
      <div class="col">
        <div id="grpboxStatusStep" class="mt-3 px-3 py-4">
            <div id="label" class="px-2 bg-secondary text-white">เลือกรูปแบบสถานะใบสั่งตรวจ</div>
                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                      <input type="radio" id="StatusStep0" value="0" name="StatusStep" v-model="curRecord.StatusStep">
                      </div>
                    </div>
                    <label for="StatusStep0">
                      <span class="btn badge bg-info rounded-pill mx-2" >New</span>
                      <span class="btn badge bg-primary rounded-pill mx-2" >Lab</span>
                      <span class="btn badge bg-warning rounded-pill mx-2" >Resulted</span>
                      <span class="btn badge bg-danger rounded-pill mx-2" >Approved</span>
                      กรณีมีหลายสาขา มีขั้นตอนการรับเข้าห้องแล็บเพื่อรีเช็ค specimen ที่ส่งมา
                    </label>
                </div>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                      <div class="input-group-text">
                      <input type="radio" id="StatusStep1" value="1" name="StatusStep" v-model="curRecord.StatusStep">
                      </div>
                  </div>
                  <label for="StatusStep1">
                      <span class="btn badge bg-info rounded-pill mx-2" >New</span>
                      <span class="btn badge text-white bg-white rounded-pill mx-2" >Lab</span>
                      <span class="btn badge bg-warning rounded-pill mx-2" >Resulted</span>
                      <span class="btn badge bg-danger rounded-pill mx-2" >Approved</span>
                      กรณีไม่มีสาขา สามารถลดขั้นตอนรับเข้าห้องแล็บ เพื่อความสะดวก
                  </label>
                </div>
        </div>
      </div>
    </div>

    <!-- ระบุ เทสสำหรับใช้ในสมการ ให้ระบบทราบ  -->
    <div class="row">
      <!-- ระบุฟิลด์ของ เทสที่ใช้ในสมการต่างๆ  -->
      <div class="col-6">
        <div id="grpboxTestSetting" class="mt-3 py-4">
          <div class="container page-scroll">
            <div id="label" class="px-2 bg-warning text-dark">ระบุเทสสำหรับสูตรคำนวณ <span class="badge bg-secondary">INPUT</span></div>
              <!-- ระบุ eGFR, Cr ให้ระบบทราบ -->
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;"><b>eGFR</b> :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="eGFR_ID" name="eGFR_ID" v-model="curRecord.eGFR_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="eGFR_Name" name="eGFR_Name" v-model="curRecord.eGFR_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('egfr')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('egfr')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-3">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Creatinine :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="Cr_ID" name="Cr_ID" v-model="curRecord.Cr_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="Cr_Name" name="Cr_Name" v-model="curRecord.Cr_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('cr')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('cr')">เลือก..</button>
              </div>
              <!-- ระบุ A/G Ratio : Albumin, Globulin, Total Protein ให้ระบบทราบ -->
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;"><b>A/G Ratio</b> :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="AGRatio_ID" name="AGRatio_ID" v-model="curRecord.AGRatio_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="AGRatio_Name" name="AGRatio_Name" v-model="curRecord.AGRatio_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('agratio')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('agratio')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Albumin :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="Albumin_ID" name="Albumin_ID" v-model="curRecord.Albumin_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="Albumin_Name" name="Albumin_Name" v-model="curRecord.Albumin_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('albumin')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('albumin')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Globulin :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="Globulin_ID" name="Globulin_ID" v-model="curRecord.Globulin_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="Globulin_Name" name="Globulin_Name" v-model="curRecord.Globulin_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('globulin')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('globulin')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-3">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Total Protein :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="TotalProtein_ID" name="TotalProtein_ID" v-model="curRecord.TotalProtein_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="TotalProtein_Name" name="TotalProtein_Name" v-model="curRecord.TotalProtein_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('totalprotein')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('totalprotein')">เลือก..</button>
              </div>
              <!-- LDL : สำหรับใช้คำนวณ LDL -->
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Total Cholesterol :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="TC_ID" name="TC_ID" v-model="curRecord.TC_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="TC_Name" name="TC_Name" v-model="curRecord.TC_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('tc')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('tc')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">HDL Cholesterol :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="HDL_ID" name="HDL_ID" v-model="curRecord.HDL_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="HDL_Name" name="HDL_Name" v-model="curRecord.HDL_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('hdl')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('hdl')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;"><b>LDL Cholesterol</b> :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="LDL_ID" name="LDL_ID" v-model="curRecord.LDL_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="LDL_Name" name="LDL_Name" v-model="curRecord.LDL_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('ldl')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('ldl')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-3">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Triglycerides :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="TG_ID" name="TG_ID" v-model="curRecord.TG_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="TG_Name" name="TG_Name" v-model="curRecord.TG_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('tg')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('tg')">เลือก..</button>
              </div>
              <!-- ระบุ HbA1C, eAg ให้ระบบทราบ : eAG = 28.7 * HbA1C – 46.7  -->
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">HbA1C :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="HbA1C_ID" name="HbA1C_ID" v-model="curRecord.HbA1C_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="HbA1C_Name" name="HbA1C_Name" v-model="curRecord.HbA1C_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('hba1c')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('hba1c')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-3">
                  <div class="input-group-prepend" title="ค่าเฉลี่ยกลูโคสโดยประมาณ (Estimated average glucose: eAG)">
                  <span class="input-group-text" style="width:150px;"><b>eAG</b> :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="eAG_ID" name="eAG_ID" v-model="curRecord.eAG_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="eAG_Name" name="eAG_Name" v-model="curRecord.eAG_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('eag')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('eag')">เลือก..</button>
              </div>
              <!-- ระบุ Diff WBC Count 100% : Neutrophil + Eosinophil + Basophil + Lymphocyte + Monocyte + Atypical lymphocytes ให้ระบบทราบ -->
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Neutrophil :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="Neutrophil_ID" name="Neutrophil_ID" v-model="curRecord.Neutrophil_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="Neutrophil_Name" name="Neutrophil_Name" v-model="curRecord.Neutrophil_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('neutrophil')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('neutrophil')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Eosinophil :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="Eosinophil_ID" name="Eosinophil_ID" v-model="curRecord.Eosinophil_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="Eosinophil_Name" name="Eosinophil_Name" v-model="curRecord.Eosinophil_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('eosinophil')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('eosinophil')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Basophil :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="Basophil_ID" name="Basophil_ID" v-model="curRecord.Basophil_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="Basophil_Name" name="Basophil_Name" v-model="curRecord.Basophil_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('basophil')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('basophil')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Lymphocyte :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="Lymphocyte_ID" name="Lymphocyte_ID" v-model="curRecord.Lymphocyte_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="Lymphocyte_Name" name="Lymphocyte_Name" v-model="curRecord.Lymphocyte_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('lymphocyte')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('lymphocyte')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Monocyte :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="Monocyte_ID" name="Monocyte_ID" v-model="curRecord.Monocyte_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="Monocyte_Name" name="Monocyte_Name" v-model="curRecord.Monocyte_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('monocyte')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('monocyte')">เลือก..</button>
              </div>
              <div class="input-group input-group-sm mb-1">
                  <div class="input-group-prepend">
                  <span class="input-group-text" style="width:150px;">Atypical Lymp :</span>
                  </div>
                  <input type="text" class="form-control form-control-sm bg-warning" ref="AtypicalLymp_ID" name="AtypicalLymp_ID" v-model="curRecord.AtypicalLymp_ID" readonly hidden>
                  <input type="text" class="form-control form-control-sm" style="background-color:PapayaWhip;" ref="AtypicalLymp_Name" name="AtypicalLymp_Name" v-model="curRecord.AtypicalLymp_Name" disabled>
                  <button type="button" class="btn btn-danger ms-1" title="เคลียร์เทสที่เลือก" @click="resetTestFor('atypicallymp')">X</button>
                  <button type="button" id="btnFindPat" class="btn btn-secondary ms-1" data-bs-toggle="modal"
                    data-bs-target="#selectTestModal" @click="openTestModalFor('atypicallymp')">เลือก..</button>
              </div>
          </div>
        </div>
      </div>
      <!-- คำอธิบายสมการคำนวณด้านซ้าย -->
      <div class="col-6">
        <div class="container border mt-3 px-3 py-4 text-start">
          <div class="container p-0 page-scroll">
            <div class="container py-2 border-bottom border-2 border-dark" style="background-color:PaleGoldenRod">
              <span><b>eGFR</b> | estimated Glomerular Filtration Rate (ค่าการทำงานของไต)</span><br>
              <table class="table table-bordered border-secondary" style="font-size:80%; width:100%">
                <tr class="bg-info">
                      <th>เพศ</th>
                      <th>ระดับ serum cretinine(mg/dL)</th>
                      <th>สมการ CKD-EPI *</th>
                </tr>
                <tr>
                  <td rowspan="2">หญิง</td>
                  <td>&lt;= 0.7</td>
                  <td>GFR = 144*(Scr/0.7)^-0.329 * (0.993)^Age</td>
                </tr>
                <tr>
                  <td>&gt; 0.7</td>
                  <td>GFR = 144*(Scr/0.7)^-1.209 * (0.993)^Age</td>
                </tr>
                <tr>
                  <td rowspan="2">ชาย</td>
                  <td>&lt;= 0.9</td>
                  <td>GFR = 141*(Scr/0.9)^-0.414 * (0.993)^Age</td>
                </tr>
                <tr>
                  <td>&gt; 0.9</td>
                  <td>GFR = 141*(Scr/0.9)^-1.209 * (0.993)^Age</td>
                </tr>
              </table>
              <span  style="font-size:80%;"> <i>* สำหรับผู้มีอายุ 18 ปีขึ้นไป</i></span>
            </div>
            <div class="container py-2 border-bottom border-2 border-dark" style="background-color:SeaShell">
              <span><b>A/G Ratio</b> (Albumin/Globulin Ratio)</span><br>
              <span>A/G Ratio = Albumin / (Total_protein - Albumin)</span><br>
              <span>Globulin = Total_protein - Albumin</span><br>
            </div>
            <div class="container py-2 border-bottom border-2 border-dark" style="background-color:PaleGoldenRod">
              <span><b>Calculated LDL</b> | LDL-C (ไขมัน low-density lipoprotein)</span><br>
              <span>LDL-C = total cholesterol – HDL-C – (triglyceride/5)</span>
            </div>
            <div class="container py-2 border-bottom border-2 border-dark" style="background-color:SeaShell">
              <span><b>eAG</b> | Estimated average glucose</span><br>
              <span>eAG = 28.7 * HbA1C – 46.7 </span><br>
            </div>
            <div class="container py-2 border-bottom border-2 border-dark" style="background-color:PaleGoldenRod">
              <span><b>Differential WBC Count</b> | ผลรวมการนับแยกชนิดเม็ดเลือดขาวต้องเท่ากับ 100%</span><br>
              <span>Neutrophil + Eosinophil + Basophil + Lymphocyte + Monocyte + Atypical lymphocytes = 100 % </span><br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="row mt-4">
      <button type="button" class="btn btn-primary btn-sm pt-2 ms-3 float-start" @click="saveStatusstepData()" style="width:100px;">บันทึกข้อมูล</button>
  </div>

  <!-- Modal Form : เลือกเทส สำหรับสูตรคำนวณ -->
  <div id="selectTestModal" class="modal " tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="background-color:Gainsboro">
          <h5 class="modal-title">เลือกเทสสำหรับใช้ในสูตรคำนวณ</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-start">
            <table id="mySelectTestTable" class="table table-hover table-sm display" style="width: 100%;">
              <thead class="text-dark" style="background:LightGreen">
              <tr>
                  <th class="text-start" style="width:50px;">รหัสเทส</th>
                  <th class="text-start" style="width:300px;">ชื่อเทส</th>
                  <th style="width:40px;">คำสั่ง</th>
              </tr>
              </thead>
              <tbody>
                  <tr v-for="item in dataTestsLists" :key="item.ItemTestID" v-bind:data-id="item.ItemTestID">
                      <td class="text-start">{{ item.ItemTestCode }}</td>
                      <td class="text-start"><b>{{ item.ItemTestName }}</b></td>
                      <td>
                          <button type="button" class="btn btn-primary btn-sm py-0 mx-1" data-bs-dismiss="modal"
                            id="selectTestItem" @click="selectTestItem(item)" title="คลิกเพื่อเลือกรายการนี้">เลือก</button>
                      </td>
                  </tr>
              </tbody>
          </table>
        </div>

        <div class="modal-footer" style="background-color:Gainsboro">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'ClinicReq',
  components: {

  },
  data () {
    return {
      curTestToSet: '',
      curRecord: {
      }
    }
  },
  created () {
  },
  mounted () {
    this.getData()
  },
  props: ['dataTestsLists'],
  methods: {
    resetTestFor (strTest) {
      if (strTest === 'egfr') {
        this.curRecord.eGFR_ID = 0
        this.curRecord.eGFR_Name = ''
      }
      if (strTest === 'cr') {
        this.curRecord.Cr_ID = 0
        this.curRecord.Cr_Name = ''
      }
      // A/G ratio, Albumin, Total Protein
      if (strTest === 'agratio') {
        this.curRecord.AGRatio_ID = 0
        this.curRecord.AGRatio_Name = ''
      }
      if (strTest === 'albumin') {
        this.curRecord.Albumin_ID = 0
        this.curRecord.Albumin_Name = ''
      }
      if (strTest === 'globulin') {
        this.curRecord.Globulin_ID = 0
        this.curRecord.Globulin_Name = ''
      }
      if (strTest === 'totalprotein') {
        this.curRecord.TotalProtein_ID = 0
        this.curRecord.TotalProtein_Name = ''
      }
      // LDL : สำหรับใช้คำนวณ LDL
      if (strTest === 'tc') {
        this.curRecord.TC_ID = 0
        this.curRecord.TC_Name = ''
      }
      if (strTest === 'hdl') {
        this.curRecord.HDL_ID = 0
        this.curRecord.HDL_Name = ''
      }
      if (strTest === 'ldl') {
        this.curRecord.LDL_ID = 0
        this.curRecord.LDL_Name = ''
      }
      if (strTest === 'tg') {
        this.curRecord.TG_ID = 0
        this.curRecord.TG_Name = ''
      }
      // HbA1C, eAg
      if (strTest === 'hba1c') {
        this.curRecord.HbA1C_ID = 0
        this.curRecord.HbA1C_Name = ''
      }
      if (strTest === 'eag') {
        this.curRecord.eAG_ID = 0
        this.curRecord.eAG_Name = ''
      }
      // Diff WBC Count : 100% = Neutrophil + Eosinophil + Basophil + Lymphocyte + Monocyte
      if (strTest === 'neutrophil') {
        this.curRecord.Neutrophil_ID = 0
        this.curRecord.Neutrophil_Name = ''
      }
      if (strTest === 'eosinophil') {
        this.curRecord.Eosinophil_ID = 0
        this.curRecord.Eosinophil_Name = ''
      }
      if (strTest === 'basophil') {
        this.curRecord.Basophil_ID = 0
        this.curRecord.Basophil_Name = ''
      }
      if (strTest === 'lymphocyte') {
        this.curRecord.Lymphocyte_ID = 0
        this.curRecord.Lymphocyte_Name = ''
      }
      if (strTest === 'monocyte') {
        this.curRecord.Monocyte_ID = 0
        this.curRecord.Monocyte_Name = ''
      }
      if (strTest === 'atypicallymp') {
        this.curRecord.AtypicalLymp_ID = 0
        this.curRecord.AtypicalLymp_Name = ''
      }
    },
    // แสดงรายการ เทสทั้งหมด ให้เลือก
    openTestModalFor (strTest) {
      //
      this.curTestToSet = strTest
    },
    selectTestItem (row) {
      if (this.curTestToSet === 'egfr') {
        this.curRecord.eGFR_ID = row.ItemTestID
        this.curRecord.eGFR_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'cr') {
        this.curRecord.Cr_ID = row.ItemTestID
        this.curRecord.Cr_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      // A/G ratio, Albumin, Total Protein
      if (this.curTestToSet === 'agratio') {
        this.curRecord.AGRatio_ID = row.ItemTestID
        this.curRecord.AGRatio_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'albumin') {
        this.curRecord.Albumin_ID = row.ItemTestID
        this.curRecord.Albumin_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'globulin') {
        this.curRecord.Globulin_ID = row.ItemTestID
        this.curRecord.Globulin_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'totalprotein') {
        this.curRecord.TotalProtein_ID = row.ItemTestID
        this.curRecord.TotalProtein_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      // LDL : สำหรับใช้คำนวณ LDL
      if (this.curTestToSet === 'tc') {
        this.curRecord.TC_ID = row.ItemTestID
        this.curRecord.TC_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'hdl') {
        this.curRecord.HDL_ID = row.ItemTestID
        this.curRecord.HDL_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'ldl') {
        this.curRecord.LDL_ID = row.ItemTestID
        this.curRecord.LDL_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'tg') {
        this.curRecord.TG_ID = row.ItemTestID
        this.curRecord.TG_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      // HbA1C, eAg
      if (this.curTestToSet === 'hba1c') {
        this.curRecord.HbA1C_ID = row.ItemTestID
        this.curRecord.HbA1C_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'eag') {
        this.curRecord.eAG_ID = row.ItemTestID
        this.curRecord.eAG_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      // Diff WBC Count : 100% = Neutrophil + Eosinophil + Basophil + Lymphocyte + Monocyte
      if (this.curTestToSet === 'neutrophil') {
        this.curRecord.Neutrophil_ID = row.ItemTestID
        this.curRecord.Neutrophil_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'eosinophil') {
        this.curRecord.Eosinophil_ID = row.ItemTestID
        this.curRecord.Eosinophil_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'basophil') {
        this.curRecord.Basophil_ID = row.ItemTestID
        this.curRecord.Basophil_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'lymphocyte') {
        this.curRecord.Lymphocyte_ID = row.ItemTestID
        this.curRecord.Lymphocyte_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'monocyte') {
        this.curRecord.Monocyte_ID = row.ItemTestID
        this.curRecord.Monocyte_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
      if (this.curTestToSet === 'atypicallymp') {
        this.curRecord.AtypicalLymp_ID = row.ItemTestID
        this.curRecord.AtypicalLymp_Name = row.ItemTestName + ' (' + row.ItemTestCode + ')'
      }
    },

    getData () {
      console.log(this.globalCorpID)
      MyApiClient.get('getdata/corpInfo_where_id.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.curRecord.MemberName = resp.data.MemberName
          this.curRecord.StatusStep = resp.data.StatusStep
          // eGFR Calc
          this.curRecord.eGFR_ID = resp.data.eGFR_ID
          this.curRecord.eGFR_Name = resp.data.eGFR_Name
          this.curRecord.Cr_ID = resp.data.Cr_ID
          this.curRecord.Cr_Name = resp.data.Cr_Name
          // A/G ratio calc : Albumin, Total Protein
          this.curRecord.AGRatio_ID = resp.data.AGRatio_ID
          this.curRecord.AGRatio_Name = resp.data.AGRatio_Name
          this.curRecord.Albumin_ID = resp.data.Albumin_ID
          this.curRecord.Albumin_Name = resp.data.Albumin_Name
          this.curRecord.Globulin_ID = resp.data.Globulin_ID
          this.curRecord.Globulin_Name = resp.data.Globulin_Name
          this.curRecord.TotalProtein_ID = resp.data.TotalProtein_ID
          this.curRecord.TotalProtein_Name = resp.data.TotalProtein_Name

          // LDL Calc
          this.curRecord.TC_ID = resp.data.TC_ID
          this.curRecord.TC_Name = resp.data.TC_Name
          this.curRecord.HDL_ID = resp.data.HDL_ID
          this.curRecord.HDL_Name = resp.data.HDL_Name
          this.curRecord.LDL_ID = resp.data.LDL_ID
          this.curRecord.LDL_Name = resp.data.LDL_Name
          this.curRecord.TG_ID = resp.data.TG_ID
          this.curRecord.TG_Name = resp.data.TG_Name
          // eAG Calc
          this.curRecord.HbA1C_ID = resp.data.HbA1C_ID
          this.curRecord.HbA1C_Name = resp.data.HbA1C_Name
          this.curRecord.eAG_ID = resp.data.eAG_ID
          this.curRecord.eAG_Name = resp.data.eAG_Name
          // Diff WBC Count
          this.curRecord.Neutrophil_ID = resp.data.Neutrophil_ID
          this.curRecord.Neutrophil_Name = resp.data.Neutrophil_Name
          this.curRecord.Eosinophil_ID = resp.data.Eosinophil_ID
          this.curRecord.Eosinophil_Name = resp.data.Eosinophil_Name
          this.curRecord.Basophil_ID = resp.data.Basophil_ID
          this.curRecord.Basophil_Name = resp.data.Basophil_Name
          this.curRecord.Lymphocyte_ID = resp.data.Lymphocyte_ID
          this.curRecord.Lymphocyte_Name = resp.data.Lymphocyte_Name
          this.curRecord.Monocyte_ID = resp.data.Monocyte_ID
          this.curRecord.Monocyte_Name = resp.data.Monocyte_Name
          this.curRecord.AtypicalLymp_ID = resp.data.AtypicalLymp_ID
          this.curRecord.AtypicalLymp_Name = resp.data.AtypicalLymp_Name

          // console.log(this.curRecord)
          setTimeout(function () { $('#mySelectTestTable').DataTable() }, 500)
          // this.$nextTick(() => {
          //   $('#mySelectTestTable').DataTable()
          // })
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    saveStatusstepData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmStatusStep').serializeArray()
      var formData = {}
      // console.log('Before get form')
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      // console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_corpinfo_statusstep.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            // Refresh >> this component only
            // this.$refs.getData()
            self.getData()
            // location.reload()
            // this.$router.push('MClinics')
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    }
  }
}
</script>
<style>
.page-scroll {
  max-height: 450px;
  height: 400px;
  overflow-y: scroll;
}

#grpboxStatusStep {
  /* height: 100px;
  width: 300px; */
  background-color:snow;
  border: 1px solid black;
  position: relative;
}

#grpboxTestSetting {
  /* height: 100px;
  width: 300px; */
  background-color:snow;
  border: 1px solid black;
  position: relative;
}

#label {
position: absolute;
top: -14px;
left: 10px;
height: 25px;
/* width: 100px; */
background-color: pink;
border: 0px solid red;
text-align: center;
}

</style>
